import { render, staticRenderFns } from "./LogoutLayout.vue?vue&type=template&id=45d08900&scoped=true"
import script from "./LogoutLayout.vue?vue&type=script&lang=js"
export * from "./LogoutLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d08900",
  null
  
)

export default component.exports